import React, { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import PatientListContainer from '../containers/Therapies/PatientListContainer';
import TherapyDetailsContainer from '../containers/TherapyDetailsContainer';
import MyAccount from './MyAccount';
import AdminPage from '../containers/Admin/AdminPage';
import WorkoutDetailsContainer from '../containers/Workouts/WorkoutDetailsContainer';
import LoginPageContainer from '../containers/LoginPageConatiner';
import PageLayout from './PageLayout';
import AccountSetupContainer from '../containers/AccountSetupContainer';
import AuthenticatedRoute from './AuthenticatedRoute';
import GroupCallContainer from '../containers/GroupCallContainer';
import LeftGroupRoom from './groupRoom/LeftGroupRoom';
import { ThemeProvider } from 'styled-components';
import useTheme from './ThemeProvider/useTheme/useTheme';
import { AUTH0_REGISTRATION_START } from '../config';
import About from './About';
import NotFound from './404';
import AppointmentContainer from '../containers/AppointmentContainer';
import RegisterPageConatiner from '../containers/RegisterPageConatiner';
import AcceptAppointment from './appointment/AcceptAppointment';
import RejectAppointment from './appointment/RejectAppointment';
import ChatPageContainer from '../containers/ChatPageContainer';
import { AppAuthProvider } from "./loginSignup/AppAuthProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RedirectTo from "./RedirectTo";
import {ChatProvider} from "../contexts/chat-context";

const App: FC = () => {
  const theme = useTheme();

  const queryClient = new QueryClient();

  const router = createBrowserRouter([{
    path: '/',
    element:
        <AppAuthProvider>
          <PageLayout/>
        </AppAuthProvider>,
    errorElement: <NotFound />,
    children: [
      { index: true, element: <LoginPageContainer signIn={true} /> },

      {
        path: 'wordpress',
        element:
          <AuthenticatedRoute>
            <RedirectTo href={AUTH0_REGISTRATION_START} />
          </AuthenticatedRoute>,
      },
      {
        path: 'appointments',
        element:
          <AuthenticatedRoute>
            <AppointmentContainer />
          </AuthenticatedRoute>,
      },
      {
        path: 'about',
        element:
            <AuthenticatedRoute>
              <About/>
            </AuthenticatedRoute>,
      },
      {
        path:'therapien',
        element:
          <AuthenticatedRoute>
            <PatientListContainer />
          </AuthenticatedRoute>,
      },
      {
        path:'messages',
        element:
          <AuthenticatedRoute>
            <ChatProvider>
              <ChatPageContainer/>
            </ChatProvider>
          </AuthenticatedRoute>,
      },
      {
        path:'therapien/:therapyId/workout/:trainingId',
        element:
          <AuthenticatedRoute>
            <WorkoutDetailsContainer />
          </AuthenticatedRoute>,
      },
      {
        path:'therapien/:therapyId/workout',
        element:
          <AuthenticatedRoute>
            <WorkoutDetailsContainer />
          </AuthenticatedRoute>,
      },
      {
        path:'therapien/:therapyId',
        element:
          <AuthenticatedRoute>
            <TherapyDetailsContainer />
          </AuthenticatedRoute>
      },
      {
        path:'admin',
        element:
          <AuthenticatedRoute>
            <AdminPage />
          </AuthenticatedRoute>,
      },
      {
        path:'account',
        element:
          <AuthenticatedRoute>
            <MyAccount />
          </AuthenticatedRoute>,
      },
      {
        path:'account-setup',
        element:
            <AuthenticatedRoute>
              <AccountSetupContainer />
            </AuthenticatedRoute>,
      },
      {
        path:'404',
        element:
            <NotFound />,
      },
      {
        path:'register',
        element:
            <RegisterPageConatiner signIn={false} />,
      },
      {
        path:'teletherapie/accept/:appointmentId',
        element:
            <AcceptAppointment />,
      },
      {
        path:'teletherapie/reject/:appointmentId',
        element:
            <RejectAppointment />,
      },
      {
        path:'room/:code/verlassen/:isTrainer/:pin?',
        element:
            <LeftGroupRoom />,
      },
      {
        path:'room/:code/:pin?',
        element: 
          <GroupCallContainer />,
      },
      { path:'*', element: <NotFound /> },
    ],
  }]);

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
